module.exports = __webpack_public_path__ + "img/business.ac43fceb.png";